import cohortsPageActionTypes from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';

const INITIAL_STATE = {
  listsSearchContexts: {
    cohortsList: null,
  },
};

const reducer = createReducer(INITIAL_STATE, {
  [cohortsPageActionTypes.COHORTS_PAGE_SET_SEARCH]: (
    state: any,
    action: any,
  ) => {
    return {
      ...state,
      listsSearchContexts: {
        ...state.listsSearchContexts,
        [action.list]: action.search,
      },
    };
  },
});

export default reducer;
